// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getAnalytics } from 'firebase/analytics'
import * as firebaseui from 'firebaseui'
import { setLogLevel } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import { onMessage } from 'firebase/messaging'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: process.env.REACT_APP_SELLER_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_SELLER_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_SELLER_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_SELLER_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_SELLER_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_SELLER_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_SELLER_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication
const auth = getAuth(app)
// Initialize Firebase UI
const ui = new firebaseui.auth.AuthUI(auth)
const analytics = getAnalytics(app)

setLogLevel('debug')

const messaging = getMessaging(app)

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_SELLER_FIREBASE_VAPID_KEY,
      })
      // console.log('FCM Token:', token)
      return token
    } else {
      console.log('Notification permission not granted')
      return null
    }
  } catch (err) {
    console.error('FCM error:', err)
    return null
  }
}

// Handle foreground messages (when app is open)
export const setupForegroundMessaging = () => {
  onMessage(messaging, payload => {
    console.log('Message received in foreground:', payload)

    // Show notification using Ant Design or browser notification
    if (payload.notification) {
      // Using browser notification API
      new Notification(payload.notification.title || 'New Message', {
        body: payload.notification.body,
        icon: '/firebase-logo.png',
      })
    }
  })
}

export { app, auth, ui, analytics, messaging }
